export const colors = {
  primary: '#35A0B9',
  lightPrimary: '#87BCC9',
  lighterPrimary: '#8DE9FF',
  darkPrimary: '#00495A',
  black: '#333',
  white: '#FFFFFF',
  sidenav: '#042E37',
  sidenavActive: '#354C52',
  adminSidenav: '#00738D',
  adminSidenavActive: '#01667D',
  blue600: '#F1FCFF',
  blue500: '#D3F6FF',
  blue400: '#F8FEFF',
  alertFg: '#F46F6F',
  alertBg: '#FFF1F1',
  successFg: '#31C48D',
  successBg: '#EEFFF9',
  warningFg: '#F4C66F',
  warningBg: '#FFFEF8',
  awaitingFg: '#587FFC',
  awaitingBg: '#EFF2FD',
  changedFg: '#F3A527',
  changedBg: '#FFF6E7',
  expiredFg: '#AAA',
  expiredBg: '#FAF9F9',
  addedFg: '#9B59B6',
  addedBg: '#F5EEF8',
  placeholder: '#C9C9C9',
  oddBG: 'rgba(225, 235, 238, 0.40)',
  cardGrey: '#E1EBEE',
  cardTextGrey: '#A7A7A7',
  dealsGreen: '#35B935',
  dealsRed: '#B93535',
  orange500: '#F3A527',
  orange400: '#FEF2DE',
  gray900: '#333333',
  gray850: '#585858',
  gray800: '#777777',
  gray750: '#959595',
  gray700: '#888888',
  gray600: '#999999',
  gray400: '#C7C7C7',
  gray350: '#DFDFDF',
  gray300: '#C4C4C4',
  gray250: '#F6F9FA',
  gray200: '#D7D7D7',
  gray100: '#83A7AE',
  gray50: '#f9fafb',
  purpleTagBg: '#ECDFF7',
  purpleTagFg: '#BE5BD7',
  inputBackground: '#FAFAFA',
  tablesDivider: '#D6DDF5',
  statusDraftBg: '#F3F4F6',
  statusDraftFg: '#4B5563',
  statusDraftBorder: '#D1D5DB',
  statusPendingBg: '#EAF2FF',
  statusPendingFg: '#2563EB',
  statusPendingBorder: '#BFDBFE',
  statusMatchingBg: '#F1ECFF',
  statusMatchingFg: '#6D28D9',
  statusMatchingBorder: '#D8B4FE',
  statusConcludedBg: '#ECFDF3',
  statusConcludedFg: '#148A4F',
  statusConcludedBorder: '#A7F3D0',
  statusRejectedBg: '#FFF1F1',
  statusRejectedFg: '#D92D20',
  statusRejectedBorder: '#FECACA',
  statusWithdrawnBg: '#F7EFE3',
  statusWithdrawnFg: '#8A5A14',
  statusWithdrawnBorder: '#E6D3B5',
  statusNeutralBg: '#F3F4F6',
  statusNeutralFg: '#4B5563',
  statusNeutralBorder: '#D1D5DB',
  entityListBg: '#F9FAFB',
  entityListFg: '#4B5563',
  entityListBorder: '#D1D5DB',
  entityClubBg: '#FFF4C7',
  entityClubFg: '#795300',
  entityClubBorder: '#E8C865',
  entityFinancierBg: '#E8F7EF',
  entityFinancierFg: '#0B6B4C',
  entityFinancierBorder: '#A8DCC4',
  entityGpeBg: '#FCEDE8',
  entityGpeFg: '#934533',
  entityGpeBorder: '#E7B6A7',
  entityPlayerBg: '#F5F3FF',
  entityPlayerFg: '#6D28D9',
  entityPlayerBorder: '#DDD6FE',
  entityAdminBg: '#F5F3FF',
  entityAdminFg: '#6D28D9',
  entityAdminBorder: '#DDD6FE',
  entityUserBg: '#F8FAFC',
  entityUserFg: '#475569',
  entityUserBorder: '#CBD5E1',
  auditCategoryAccessBg: '#FCEDE8',
  auditCategoryAccessFg: '#934533',
  auditCategoryAccessBorder: '#E7B6A7',
  auditCategoryAccountBg: '#FFF1F6',
  auditCategoryAccountFg: '#BE185D',
  auditCategoryAccountBorder: '#FBCFE8',
  auditCategoryAdminBg: '#F5F3FF',
  auditCategoryAdminFg: '#6D28D9',
  auditCategoryAdminBorder: '#DDD6FE',
  auditCategoryAuthenticationBg: '#EAFBF2',
  auditCategoryAuthenticationFg: '#047857',
  auditCategoryAuthenticationBorder: '#B7E4C7',
  auditCategoryBusinessBg: '#EAF2FF',
  auditCategoryBusinessFg: '#1D4ED8',
  auditCategoryBusinessBorder: '#BFDBFE',
  auditCategoryIntegrationBg: '#F5F3FF',
  auditCategoryIntegrationFg: '#6D28D9',
  auditCategoryIntegrationBorder: '#DDD6FE',
  auditCategorySecurityBg: '#FFF4C7',
  auditCategorySecurityFg: '#795300',
  auditCategorySecurityBorder: '#E8C865',
  auditCategorySystemBg: '#F9FAFB',
  auditCategorySystemFg: '#4B5563',
  auditCategorySystemBorder: '#D1D5DB',
  auditResultBlockedBg: '#FFF4C7',
  auditResultBlockedFg: '#795300',
  auditResultFailureBg: '#FFF1F1',
  auditResultFailureFg: '#D92D20',
  auditResultSuccessBg: '#ECFDF3',
  auditResultSuccessFg: '#148A4F',
  auditResultUnknownBg: '#F3F4F6',
  auditResultUnknownFg: '#4B5563',
  auditRelationshipOriginatedBg: '#EAFBF2',
  auditRelationshipOriginatedFg: '#047857',
  auditRelationshipOriginatedBorder: '#B7E4C7',
  auditRelationshipTargetedBg: '#FFF4C7',
  auditRelationshipTargetedFg: '#795300',
  auditRelationshipTargetedBorder: '#E8C865',
  auditRelationshipOriginatedTargetedBg: '#F5F3FF',
  auditRelationshipOriginatedTargetedFg: '#6D28D9',
  auditRelationshipOriginatedTargetedBorder: '#DDD6FE',
  auditRelationshipRelatedBg: '#F9FAFB',
  auditRelationshipRelatedFg: '#4B5563',
  auditRelationshipRelatedBorder: '#D1D5DB',
  auditSubjectDefaultFg: '#374151',
  auditSubjectDeletedFg: '#B85B5B',
  auditSubjectSessionBg: '#F5F3FF',
  auditSubjectSessionFg: '#6D28D9',
  auditSubjectSessionBorder: '#DDD6FE',
  environmentLocalBg: '#9333EA',
  environmentLocalFg: '#FFFFFF',
  environmentDevBg: '#10B981',
  environmentDevFg: '#111827',
  environmentStgBg: '#FBBF24',
  environmentStgFg: '#111827',
  environmentTestBg: '#0EA5E9',
  environmentTestFg: '#111827',
};
